function PublicLoginController(){
	this.className	= "PublicLoginController";
	this.glob		= "/login**";
};
PublicLoginController.inheritsFrom( StandardController );
PublicLoginController.prototype.on = function(){
	this.contactForm = new PublicLoginForm({controller:this});
};
PublicLoginController.prototype.off = function(){
	this.contactForm.destroy();
};